import script from "./DictionarySearchBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionarySearchBlock.vue?vue&type=script&setup=true&lang=js"

import "./DictionarySearchBlock.vue?vue&type=style&index=0&id=5e7015f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7015f6"]])

export default __exports__